import React from 'react';
import PropTypes from 'prop-types';
import Button from 'common/components/elements/buttons/primary';
import NewButton from 'common/components-v2/elements/button';
import IconLabel from 'common/components/elements/icon-label';
import cx from 'classnames'

const ConfirmModalContent = ({
   action,
   isLoading,
   disabled,
   descriptionColorClass,
   title,
   children,
   icon,
   iconColor,
   description,
   buttonText = 'Discard changes',
   nonPrimaryColor,
   textColor,
   cancelText,
   withoutCancelButton,
   isNeedHelpButton,
   buttonClassName = 'mt-6',
   className = '',
   closeModal,
   iconSize,
   primaryButtonClassName = '',
   buttonIconName = '',
   cancelButtonAction,
   withoutConfirmButton = false,
   secondDescription = '',
   secondDescriptionClassName = '',
   withoutCloseButton = true,
   isPreventDeafault = true,
   titleClassName = '',
   closeBtnClassName = '!w-fit',
   secondaryButtonClassName,
   titleLeading,
   descriptionLeading,
   secondButtonTitle = '',
   secondButtonClassName,
   secondButtonAction,
   secondButtonDisabled,
   confirmButtonProperties = {},
   isStopPropagation,
   confirmButtonHight = '9',
   isTitleHtml = false,
   overrideSecondButtonProps = {},
   headerNewElementId = '',
   imageAsIconSrc,
   cancelButtonWrapperClassName = '',
   TopDescriptionComponent,
   cancelButtonProperties = {},
   secondButtonWrapperClassName = '',
   headerIconComponent,
   isScrollableTopPartWithoutButtons,
   isMobile,
   scrollableContentWrapperId,
   dataToolTipContent,
   scrollableContentWrapperClassName = '',
   imageAsIconClassName,
   primaryColor,
   isNewVersion,
}) => {

   const modalTopView = (
      <>
         {
            icon && (
               <IconLabel
                  color={ iconColor }
                  isPrimary={ !iconColor }
                  name={ icon }
                  size={ iconSize }
                  className='h-10 w-10 mb-3 shrink-0'
                  primaryColor={ primaryColor }
                  isNewVersion={ isNewVersion }
               />
            )
         }
         {
            Boolean(imageAsIconSrc) && (
               <div
                  className='w-10 h-10 mb-3 shrink-0'
               >
                  <img
                     src={ imageAsIconSrc }
                     alt={ title }
                     className={ cx({
                        'w-full h-full object-cover object-center': true,
                        [`${ imageAsIconClassName }`]: Boolean(imageAsIconClassName),
                     }) }
                  />
               </div>
            )
         }
         {
            Boolean(headerIconComponent) && (
               headerIconComponent
            )
         }
         {
            isTitleHtml ? (
               <span
                  className={ cx({
                     [`text-xl font-semibold ${ titleLeading } ${ titleClassName } cursor-default`]: true,
                     'text-gray dark:text-gray-dark': isNewVersion,
                     'text-major dark:text-major-dark': !isNewVersion,
                  }) }
                  dangerouslySetInnerHTML={ { __html: title } }
               />
            ) : (
               <span
                  className={ cx({
                     [`text-xl font-semibold ${ titleLeading } ${ titleClassName } cursor-default`]: true,
                     'text-gray dark:text-gray-dark': isNewVersion,
                     'text-major dark:text-major-dark': !isNewVersion,
                  }) }
               >{title}</span>
            )
         }
         {
            Boolean(TopDescriptionComponent) && (
               TopDescriptionComponent
            )
         }
         {
            description && (
               <span
                  dangerouslySetInnerHTML={ { __html: description } }
                  className={ cx({
                     [`${ descriptionLeading } font-normal mt-4 cursor-default`]: true,
                     'text-gray-600 dark:text-gray-dark-600': !descriptionColorClass && isNewVersion,
                     'text-secondary dark:text-secondary-dark': !descriptionColorClass && !isNewVersion,
                     [`${ descriptionColorClass }`]: descriptionColorClass,
                  }) }
               />
            )
         }
         {
            !!secondDescription &&
            <span className={ secondDescriptionClassName }>
               {secondDescription}
            </span>
         }
         {
            !!headerNewElementId &&
            <div id={ headerNewElementId } />
         }
         {
            children && children
         }
      </>
   )

   return (
      <>
         {
            !withoutCloseButton && (
               <div
                  className={ cx({
                     'h-10 w-10 min-w-[40px] flex items-center justify-center my-2 mr-2 ml-auto': true,
                     [`${ closeBtnClassName }`]: Boolean(closeBtnClassName),
                     'shrink-0': isScrollableTopPartWithoutButtons,
                  }) }
               >
                  {
                     isNewVersion && (
                        <NewButton
                           buttonType='button'
                           leftIconName='close'
                           onClick={ closeModal }
                           size='medium'
                           type='tertiary'
                        />
                     )
                  }
                  {
                     !isNewVersion && (
                        <Button
                           iconName='close'
                           fontIconColor='secondary'
                           darkIconColor='secondary-dark'
                           backgroundColor='transparent'
                           onClick={ closeModal }
                           padding='none'
                           classNames='h-6 w-6'
                           fontIconSize='extraLarge'
                        />

                     )
                  }
               </div>

            )
         }
         <div
            role='presentation'
            onClick={ e => {
               if(isPreventDeafault) {
                  e.preventDefault()
               }
               if(isStopPropagation) {
                  e.stopPropagation()
               }
            } }
            className={ cx({
               [`flex flex-col items-center ${ className } text-center modal-action select-text`]: true,
               'p-6': withoutCloseButton,
               'px-6 pb-6': !withoutCloseButton,
               'max-h-full flex-1 overflow-y-hidden': isScrollableTopPartWithoutButtons,
            }) }
         >
            {
               isScrollableTopPartWithoutButtons ? (
                  <div
                     className={ cx({
                        'w-full flex flex-col items-center overflow-y-auto ams-custom-scrool': true,
                        // 'ams-custom-scrool': !isMobile,
                        [scrollableContentWrapperClassName]: scrollableContentWrapperClassName,
                     }) }
                     id={ scrollableContentWrapperId }
                  >
                     {modalTopView}
                  </div>
               ) : (
                  modalTopView
               )
            }
            {
               !withoutConfirmButton &&
                  <div
                     className={ cx({
                        [`h-${ confirmButtonHight } ${ buttonClassName }`]: true,
                        'opacity-50': disabled,
                        'shrink-0': isScrollableTopPartWithoutButtons,
                     }) }
                  >
                     {
                        isNewVersion && (
                           <NewButton
                              text={ buttonText }
                              leftIconName={ buttonIconName }
                              onClick={ action }
                              size='medium'
                              type='link'
                              dataToolTipContent={ dataToolTipContent }
                              disabled={ disabled }
                              loading={ isLoading }
                              className={ primaryButtonClassName }
                              { ...confirmButtonProperties }
                           />
                        )
                     }
                     {
                        !isNewVersion && (
                           <Button
                              text={ buttonText }
                              borderRadius='large'
                              backgroundColor='transparent'
                              textColor={ nonPrimaryColor ? textColor : null }
                              textSize='small'
                              onClick={ action }
                              padding='none'
                              classNames={ `h-full w-full ${ primaryButtonClassName }` }
                              isLoading={ isLoading }
                              loaderColor='blue'
                              primaryColor={ !nonPrimaryColor }
                              fontWeight='medium'
                              disabled={ disabled }
                              iconName={ buttonIconName }
                              fontIconSize='base'
                              { ...confirmButtonProperties }
                              dataToolTipContent={ dataToolTipContent }
                           />

                        )
                     }
                  </div>
            }
            {
               !!secondButtonTitle &&
               <div
                  className={ cx({
                     'h-9 mt-3': true,
                     [`${ secondButtonWrapperClassName }`]: Boolean(secondButtonWrapperClassName),
                     'shrink-0': isScrollableTopPartWithoutButtons,
                  }) }
               >
                  {
                     !isNewVersion && (
                        <Button
                           text={ secondButtonTitle }
                           borderRadius='large'
                           onClick={ secondButtonAction }
                           padding='none'
                           classNames={ `h-full w-full ${ secondButtonClassName }` }
                           fontWeight='medium'
                           textClassName='text-error dark:text-error-dark'
                           textColor='error'
                           disabledElClassName='!text-disabled'
                           textSize='small'
                           backgroundColor='transparent'
                           disabled={ secondButtonDisabled }
                           { ...overrideSecondButtonProps }
                        />

                     )
                  }
                  {
                     isNewVersion && (
                        <NewButton
                           buttonType='button'
                           isDistructive
                           onClick={ secondButtonAction }
                           size='medium'
                           text={ secondButtonTitle }
                           type='link'
                           className={ secondButtonClassName }
                           disabled={ secondButtonDisabled }
                           { ...overrideSecondButtonProps }
                        />
                     )
                  }
               </div>
            }
            {
               !withoutCancelButton && (
                  <div
                     className={ cx({
                        'h-9 mt-3': true,
                        [`${ cancelButtonWrapperClassName }`]: Boolean(cancelButtonWrapperClassName),
                        'shrink-0': isScrollableTopPartWithoutButtons,
                     }) }
                  >
                     {
                        isNewVersion && (
                           <NewButton
                              onClick={ (e) => {
                                 if(cancelButtonAction){
                                    return cancelButtonAction();
                                 }
                                 closeModal(e);
                              } }
                              size='medium'
                              text={ cancelText ||  'Cancel' }
                              type='tertiary'
                              className={ secondaryButtonClassName }
                              { ...cancelButtonProperties }

                           />
                        )
                     }
                     {
                        !isNewVersion && (
                           <Button
                              text={ cancelText ||  'Cancel' }
                              borderRadius='large'
                              backgroundColor='transparent'
                              textColor={ isNeedHelpButton ? 'placeholder' : 'secondary dark:text-secondary-dark' }
                              textSize='small'
                              onClick={ (e) => {
                                 if(cancelButtonAction){
                                    return cancelButtonAction();
                                 }
                                 closeModal(e);
                              } }
                              padding='none'
                              classNames={ `h-full w-full ${ secondaryButtonClassName }` }
                              fontWeight='medium'
                              { ...cancelButtonProperties }
                           />
                        )
                     }
                  </div>
               )
            }
         </div>
      </>
   );
}


ConfirmModalContent.propTypes = {
   action: PropTypes.func,
   closeModal: PropTypes.func,
   isLoading: PropTypes.bool,
   disabled: PropTypes.bool,
   descriptionColorClass: PropTypes.string,
   title: PropTypes.string,
   children: PropTypes.any,
   icon: PropTypes.string,
   iconColor: PropTypes.string,
   description: PropTypes.string,
   buttonText: PropTypes.string,
   nonPrimaryColor: PropTypes.bool,
   textColor: PropTypes.string,
   cancelText: PropTypes.string,
   withoutCancelButton: PropTypes.bool,
   isNeedHelpButton: PropTypes.bool,
   buttonClassName: PropTypes.string,
   className: PropTypes.string,
   iconSize: PropTypes.string,
   buttonIconName: PropTypes.string,
   primaryButtonClassName: PropTypes.string,
   cancelButtonAction: PropTypes.func,
   withoutConfirmButton: PropTypes.bool,
   secondDescription: PropTypes.string,
   secondDescriptionClassName: PropTypes.string,
   withoutCloseButton: PropTypes.bool,
   isPreventDeafault: PropTypes.bool,
   titleClassName: PropTypes.string,
   closeBtnClassName: PropTypes.string,
   secondaryButtonClassName: PropTypes.string,
   titleLeading: PropTypes.string,
   descriptionLeading: PropTypes.string,
   secondButtonTitle: PropTypes.string,
   secondButtonClassName: PropTypes.string,
   secondButtonAction: PropTypes.func,
   secondButtonDisabled: PropTypes.bool,
   confirmButtonProperties: PropTypes.object,
   isStopPropagation: PropTypes.bool,
   headerNewElementId: PropTypes.string,
   confirmButtonHight: PropTypes.string,
   isTitleHtml: PropTypes.bool,
   overrideSecondButtonProps: PropTypes.object,
   imageAsIconSrc: PropTypes.string,
   cancelButtonWrapperClassName: PropTypes.string,
   TopDescriptionComponent: PropTypes.any,
   cancelButtonProperties: PropTypes.object,
   secondButtonWrapperClassName: PropTypes.string,
   headerIconComponent: PropTypes.any,
   isScrollableTopPartWithoutButtons: PropTypes.bool,
   isMobile: PropTypes.bool,
   scrollableContentWrapperId: PropTypes.string,
   dataToolTipContent: PropTypes.string,
   scrollableContentWrapperClassName: PropTypes.string,
   imageAsIconClassName: PropTypes.string,
   primaryColor: PropTypes.string,
   isNewVersion: PropTypes.bool,
};


export default ConfirmModalContent;
